import { render, staticRenderFns } from "./AppointmentModificationModal.vue?vue&type=template&id=4ab2bd55"
import script from "./AppointmentModificationModal.vue?vue&type=script&lang=ts"
export * from "./AppointmentModificationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports